import React from "react";
import { motion } from "framer-motion";
import WaitlistForm from "@/components/landing/WaitlistForm";

export default function CTASection() {
  return (
    <section
      id="waitlist"
      data-testid="cta-section"
      className="py-24 md:py-32 relative overflow-hidden bg-white"
    >
      <div className="absolute inset-0 grid-bg pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[500px] w-[500px] rounded-full bg-[#084392]/10 blur-3xl pointer-events-none" />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="relative mx-auto max-w-4xl px-5 md:px-8 text-center"
      >
        <div className="inline-flex items-center gap-2 rounded-full border border-[#e2e8f0] bg-white px-3 py-1.5 text-xs font-semibold text-[#084392] font-mono tracking-[0.15em]">
          LIMITED EARLY ACCESS
        </div>
        <h2 className="font-heading mt-6 text-5xl md:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.98]">
          Tired of being
          <br />
          <span className="text-[#084392]">your own worst trader?</span>
        </h2>
        <p className="mt-6 text-lg md:text-xl text-[#475569] max-w-2xl mx-auto leading-relaxed">
          Join the waitlist. Lock in early-adopter pricing, get priority access
          the day we go live, and finally stop fighting your own emotions.
        </p>

        <div className="mt-10 max-w-xl mx-auto">
          <WaitlistForm source="cta-section" size="lg" />
          <p className="mt-3 text-sm text-[#94a3b8]">
            No spam. No credit card. Unsubscribe anytime.
          </p>
        </div>
      </motion.div>
    </section>
  );
}
